module.exports = __webpack_public_path__ + "img/02_uk.2dfb5b40.svg";